import React from "react";

import Navbar from "./components/navbar";
import Intro from "./components/intro";

function Header(){
    return (
    <div>
        <Navbar/>
        <Intro />
    </div>
    )
}

export default Header;